import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { ButtonNew as Button } from "components/buttonNew";
import Input from "components/form/input/index";
import { Select } from "components/select/index";
import Spin from "components/spin/spin";
import { IWebsiteBuilderIconAssetIdentity } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderIcon";
import { WebsiteBuilderPanelContent } from "pages/secure/facility/websiteBuilder/editor/shell/panel/content/WebsiteBuilderPanelContent";
import { WEBSITE_BUILDER_PORTAL } from "pages/secure/facility/websiteBuilder/editor/WebsiteBuilderEditor";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IWebsiteBuilderIconAsset } from "redux/reducers/models/websiteBuilder";
import { useWebsiteBuilderIconPicker } from "./useWebsiteBuilderIconPicker";

interface IWebsiteBuilderBrowseIconsProps {
  assetIdentity: IWebsiteBuilderIconAssetIdentity;
  onBack: () => void;
  onSelect: (asset: IWebsiteBuilderIconAsset) => void;
}

export function WebsiteBuilderBrowseIcons(props: IWebsiteBuilderBrowseIconsProps) {
  const { assetIdentity, onBack, onSelect } = props;

  const { t } = useTranslation();

  const { iconPickerState, lastIconRef, setSelectedVariantCode, setAssetSearchValue } = useWebsiteBuilderIconPicker(assetIdentity, true, ".panel-content-sections");

  return (
    <WebsiteBuilderPanelContent
      title={t("Browse all icons")}
      closePanel={onBack}
      sections={[
        <div className="website-builder-browse-icons" key="browse-icons">
          {iconPickerState.variantsLoading ? (
            <div className="select-icon-loading-spin-container">
              <Spin className="select-icon-loading-spin" />
            </div>
          ) : (
            <>
              <div className="select-icon-controls">
                <Input
                  labelHidden
                  value={iconPickerState.assetSearchValue}
                  placeholder={t("Search an icon...")}
                  icon={faMagnifyingGlass}
                  onChange={e => setAssetSearchValue(e.target.value)}
                  onSearchClear={() => setAssetSearchValue("")}
                />
                <Select
                  defaultValue={iconPickerState.selectedVariantCode}
                  onChange={setSelectedVariantCode}
                  disabled={iconPickerState.variantsLoading}
                  usePortal
                  portalId={WEBSITE_BUILDER_PORTAL}
                >
                  {iconPickerState.variants.map(variant => (
                    <Select.Option key={variant.code} value={variant.code}>
                      {variant.title}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              {iconPickerState.assetsLoading ? (
                <div className="select-icon-loading-spin-container">
                  <Spin className="select-icon-loading-spin" />
                </div>
              ) : (
                <div className="select-icon-options">
                  {iconPickerState.filteredAssets.slice(0, iconPickerState.renderCount).map((asset, index) => (
                    <OverlayTrigger
                      key={asset.asset_code}
                      placement="left"
                      popperConfig={{ strategy: "fixed" }}
                      transition={false}
                      delay={{
                        show: 500,
                        hide: 0,
                      }}
                      overlay={
                        <Tooltip id={`website-builder-browse-icon-asset-${asset.asset_code}`}>
                          {asset.title}
                        </Tooltip>
                      }
                    >
                      <button
                        ref={index === Math.min(iconPickerState.filteredAssets.length, iconPickerState.renderCount) - 1 ? lastIconRef : null}
                        type="button"
                        aria-label={asset.title}
                        onClick={() => onSelect(asset)}
                        dangerouslySetInnerHTML={{ __html: asset.svg }}
                      />
                    </OverlayTrigger>
                  ))}
                </div>
              )}
            </>
          )}
        </div>,
      ]}
      footer={(
        <Button size="small" type="secondary" onClick={onBack} block>
          {t("Go back")}
        </Button>
      )}
    />
  );
}
